import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectComponent, GroupSelectOptionComponent } from '@rma/generic/ui/forms/group-select';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { filter, take } from 'rxjs';
import { WhyAreYouHereOptionType, WhyAreYouHereOptions } from '../domain/why-are-you-here-options';
import { FindMyAgentStore } from '../orc-find-my-agent/find-my-agent.store';

@Component({
  selector: 'rma-why-are-you-here',
  imports: [GroupSelectComponent, GroupSelectOptionComponent, RmaIconComponent, ReactiveFormsModule, TranslocoModule],
  templateUrl: './why-are-you-here.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhyAreYouHereComponent {
  public readonly options = WhyAreYouHereOptions;

  public control = new FormControl<WhyAreYouHereOptionType | null>(null, [Validators.required]);

  protected store = inject(FindMyAgentStore);

  constructor() {
    this.control.valueChanges
      .pipe(filter(Boolean), take(1))
      .subscribe((reason) => this.store.patchState({ nextStep: reason === 'selling' ? 'propertytype' : reason }));
  }
}
